// استيراد useContext لاستخدام الـ Context API
import { useContext } from 'react';

// استيراد صورة الخلفية
import imge from '../../img/main.png.jpg';

// استيراد الكونتكست اللي فيه المنتجات والفلاتر
import { ProductsContext } from '../Context/CounterStore';
import { useCart } from '../Context/Cart'; // ✅ استيراد كونتكست السلة
import { Link } from 'react-router-dom';

export default function Home() {

    // استخدام Context عشان نوصل للمنتجات والفانكشن الخاصة بالفلترة
    const { filteredProducts, filterByCategory } = useContext(ProductsContext);

    // استخدام دالة إضافة للسلة من الـ Cart Context
    const { addToCart } = useCart(); // ✅

    return <>
        {/* بانر كبير في أول الصفحة بصورة وكلام ترويجي */}
        <div className="card bg-dark text-white border-0 rounded-4 mx-3">
            <img src={imge} className="card-img" alt="..." style={{ height: "80vh", objectFit: "cover" }} />
            <div className="card-img-overlay d-flex flex-column justify-content-center px-4">
                <div className="container">
                    <h1 className="card-title fw-bold">New Season Arrivals</h1>
                    <p className="card-text fs-5">
                        This is a wider card with supporting text below as a natural lead-in to additional content.
                        This content is a little bit longer.
                    </p>
                </div>
            </div>
        </div>

        {/* عنوان قسم المنتجات الأحدث */}
        <div className="container text-center py-5">
            <h1>Latest Products</h1>
            <hr />
        </div>

        {/* أزرار فلترة المنتجات حسب التصنيف */}
        <div className="container text-center py-3">
            <button className="btn btn-outline-dark mx-2" onClick={() => filterByCategory('all')}>All</button>
            <button className="btn btn-outline-dark mx-2" onClick={() => filterByCategory("men's clothing")}>Men's Clothing</button>
            <button className="btn btn-outline-dark mx-2" onClick={() => filterByCategory("women's clothing")}>Women's Clothing</button>
            <button className="btn btn-outline-dark mx-2" onClick={() => filterByCategory('jewelery')}>Jewelry</button>
            <button className="btn btn-outline-dark mx-2" onClick={() => filterByCategory('electronics')}>Electronics</button>
        </div>

        {/* الحاوية الرئيسية اللي فيها كل المنتجات */}
        <div className="container">
            <div className="row justify-content-center">

                {/* تكرار عرض المنتجات */}
                {filteredProducts.map((product) => (
                    <div key={product.id} className="col-md-3 col-sm-6 mb-4 d-flex justify-content-center">
                        <div className="card h-100 shadow-sm" style={{ width: '100%', maxWidth: '250px', borderRadius: '8px' }}>
                            <img src={product.image} className="card-img-top p-3" style={{ height: '200px', objectFit: 'contain' }} alt={product.title} />

                            <div className="card-body d-flex flex-column justify-content-between">
                                <div>
                                    <h6 className="card-title" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                        {product.title.slice(0, 20)}...
                                    </h6>

                                    <p className="card-text text-muted" style={{ fontSize: '12px', marginTop: '5px' }}>
                                        {product.description.slice(0, 30)}...
                                    </p>

                                    <p className="card-text mt-2" style={{ fontSize: '16px', color: '#28a745', fontWeight: 'bold' }}>
                                        ${product.price}
                                    </p>
                                </div>

                                {/* أزرار الشراء والإضافة للسلة */}
                                <div className="mt-3">
                                    {/* زر Buy Now بيروّح لصفحة التفاصيل */}
                                    <Link to={`/product/${product.id}`}>
                                        <button className="btn btn-outline-dark btn-sm me-3">Buy Now</button>
                                    </Link>

                                    {/* زر Add to Cart بيروح للسلة */}
                                    <button 
                                        className="btn btn-outline-dark btn-sm"
                                        onClick={() => addToCart(product)} // ✅ عند الضغط نضيف المنتج للسلة
                                    >
                                        Add to Cart
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </>
}
